"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const dayOfWeek_1 = __importStar(require("../../utils/dayOfWeek"));
require("./styles.scss");
const react_i18next_1 = require("react-i18next");
function LocationHoursTable({ currDay, hours, hoursFormatter, dayFormatter, holidays, holidayFilter, schedule, circularWeek }) {
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    const getIsoDaysOfWeek = () => {
        var _a;
        if (schedule) {
            return (_a = schedule.iso_weekdays) !== null && _a !== void 0 ? _a : [];
        }
        /* For a circular week, each weekday that passes becomes the new tail end of the week.
           A circular week behaves like a weekly calendar, showing upcoming days (that may be Holidays).
         */
        if (circularWeek) {
            let cirWeek = new Array(7);
            return cirWeek
                .fill(1)
                .map((_, // Rotate and fill weekday numbers starting from today.
            idx // e.g. dayOfWeek = 6: [6, 7, 1, 2, 3, 4, 5]
            ) => (((currDay.n - 1 + idx) % 7) + 1));
        }
        // return standard week ([1,2,3,4,5,6,7])
        return dayOfWeek_1.IsoDaysOfWeek;
    };
    const closureMessageForDay = (sysDayName, hours, holiday) => {
        if (holiday && hours && hours[sysDayName].length)
            return t("closedForHoliday");
        if (hours && !hoursFormatter(hours[sysDayName]).length)
            return t("closed");
    };
    return ((0, jsx_runtime_1.jsx)("table", Object.assign({ className: `hours-table ontario-margin-bottom-7` }, { children: (0, jsx_runtime_1.jsx)("tbody", { children: getIsoDaysOfWeek()
                .map((dayIndex, i) => {
                const dayName = (schedule && dayFormatter) ? dayFormatter(i) : (0, dayOfWeek_1.default)(dayIndex, t);
                const systemDayName = (0, dayOfWeek_1.dayOfWeekAsString)(dayIndex);
                const holidayMatch = (0, dayOfWeek_1.matchWeekdayHoliday)({ n: dayIndex, tz: currDay.tz }, holidays, holidayFilter, schedule === null || schedule === void 0 ? void 0 : schedule.dates[i].date);
                const holiday = holidayMatch === null || holidayMatch === void 0 ? void 0 : holidayMatch.holiday;
                const showObserved = holidayMatch === null || holidayMatch === void 0 ? void 0 : holidayMatch.matchedServiceHoliday;
                const closureMessage = closureMessageForDay(systemDayName, hours, holiday);
                return ((0, jsx_runtime_1.jsxs)("tr", Object.assign({ className: (!schedule && (currDay.n === dayIndex)) ? 'strong' : "" }, { children: [(0, jsx_runtime_1.jsxs)("th", { children: [dayName, holiday && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: `table-holiday` }, { children: [holiday[i18n.language === "en" ? "english" : "french"], showObserved && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("br", {}), "(", t("observedHoliday"), ")"] }))] }))] }))] }), (0, jsx_runtime_1.jsx)("td", { children: closureMessage !== null && closureMessage !== void 0 ? closureMessage : (hours && hoursFormatter(hours[systemDayName])) })] }), `${systemDayName}-${i}`));
            }) }) })));
}
exports.default = LocationHoursTable;
